'use strict';

/**
 * Icon Component Style for tingle
 * @author fushan
 *
 * Copyright 2014-2016, Tingle Team, Alinw.
 * All rights reserved.
 */

module.exports = require('./Icon');
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7QUFRQSxPQUFPLE9BQVAsR0FBaUIsUUFBUSxRQUFSLENBQWpCIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBJY29uIENvbXBvbmVudCBTdHlsZSBmb3IgdGluZ2xlXG4gKiBAYXV0aG9yIGZ1c2hhblxuICpcbiAqIENvcHlyaWdodCAyMDE0LTIwMTYsIFRpbmdsZSBUZWFtLCBBbGludy5cbiAqIEFsbCByaWdodHMgcmVzZXJ2ZWQuXG4gKi9cblxubW9kdWxlLmV4cG9ydHMgPSByZXF1aXJlKCcuL0ljb24nKTtcbiJdLCJzb3VyY2VSb290IjoiL3NvdXJjZS8ifQ==



/*****************
 ** WEBPACK FOOTER
 ** ./~/@ali/tingle-icon/dist/index.js
 ** module id = 51
 ** module chunks = 0
 **/